import { render, staticRenderFns } from "./EvidenceCategoryCard.vue?vue&type=template&id=48596a6c"
import script from "./EvidenceCategoryCard.vue?vue&type=script&lang=ts"
export * from "./EvidenceCategoryCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports